import Alert from "@amzn/meridian/alert";
import Button from "@amzn/meridian/button";

interface LoadErrorProps {
  /** What failed to load, e.g. "documents". */
  subject: string;
  onRetry: () => void;
}

/**
 * Shown in place of a table or page body when a load fails. Without this an
 * empty table is indistinguishable from a successful request that returned
 * nothing.
 */
const LoadError = ({ subject, onRetry }: LoadErrorProps) => (
  <Alert type="error" size="medium">
    {`Could not load ${subject}. `}
    <Button type="link" size="small" onClick={onRetry}>
      Try again
    </Button>
  </Alert>
);

export default LoadError;
